import { useEffect, useState } from "react";
import { fetchHistory } from "@/lib/api";
import { Clock, ArrowUpRight } from "@phosphor-icons/react";

export default function HistoryPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    fetchHistory(50)
      .then((data) => alive && setItems(data))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-12">
      <span className="text-xs font-semibold uppercase tracking-wider text-blue-600">
        / Generation history
      </span>
      <h1 className="font-bold text-3xl md:text-5xl mt-3 mb-10 text-slate-900">
        Your content kits
      </h1>

      {loading && <p className="text-slate-400 text-sm">Loading…</p>}

      {!loading && items.length === 0 && (
        <div className="border border-slate-200 p-10 text-center text-slate-400 rounded-xl" data-testid="empty-history">
          <Clock size={32} className="mx-auto mb-4 text-slate-300" />
          <p className="uppercase tracking-wider text-sm">
            No content generated yet. Pick a story and forge your first kit.
          </p>
        </div>
      )}

      <div className="space-y-3" data-testid="history-list">
        {items.map((it) => (
          <div
            key={it.id}
            className="border border-slate-200 bg-white p-5 md:p-6 hover:border-slate-300 hover:shadow-sm transition-all rounded-xl"
            data-testid="history-item"
          >
            <div className="flex items-center gap-3 mb-2 flex-wrap">
              <span className="text-[11px] font-semibold uppercase tracking-wider text-blue-600">
                {it.source}
              </span>
              <span className="text-[11px] uppercase tracking-wider text-slate-400">
                {new Date(it.created_at).toLocaleString()}
              </span>
            </div>
            <h3 className="font-bold text-lg md:text-xl mb-3 text-slate-900">{it.title}</h3>
            {it.title_suggestions?.length > 0 && (
              <div className="text-xs text-slate-500 mb-2">
                <span className="uppercase tracking-wider text-slate-400">Suggested title: </span>
                {it.title_suggestions[0]}
              </div>
            )}
            {it.link && (
              <a
                href={it.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-xs text-slate-400 hover:text-slate-900"
              >
                Source <ArrowUpRight size={12} />
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
